import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { GetNetflixWebToken } from '../configs/entity.config';
import { Observable } from 'rxjs';
import { NetflixWebTokenResource } from '@dch/products-business-logic';

@Injectable({
  providedIn: 'root',
})
export class NetflixAccountManagementService {
  constructor() {}

  getNetflixToken(): Observable<IEntity<NetflixWebTokenResource>> {
    return EntityManager.getEntity(GetNetflixWebToken);
  }
}
